<template>
  <div>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div class="flex-center-between">
        <div class="flex-center">
          <img class="mr20 image-user" src="@/assets/user/image-user.png" alt/>
          <div class="info-area fz14">
            <div class="lh25">{{ userInfo.deptList[0]?.deptName.split('|')[0] }}</div>
            <div class="lh25 fc9">{{ userInfo.deptList[0]?.orgCode }}</div>
          </div>
        </div>
        <div>
          您还剩余刻章次数: {{ userInfo.makeCount }}
        </div>
      </div>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div>
        <div class="button-box">
          <el-button type="primary" icon="el-icon-plus" size="mini" @click="openCreate">新增企业</el-button>
        </div>
        <el-table
            v-loading="loading"
            :data="tableData"
            height="547"
            style="width: 100%">
          <el-table-column
              label="信用代码"
              prop="orgCode">
          </el-table-column>
          <el-table-column
              label="企业名称"
              prop="deptName">
            <template slot-scope="scope">
              <div>{{ scope.row.deptName.split('|')[0] }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="联系电话"
              prop="deptName">
            <template slot-scope="scope">
              <div>{{ scope.row.deptName.split('|')[1] }}</div>
            </template>
          </el-table-column>
          <el-table-column
              label="企业账户"
              prop="phone">
          </el-table-column>
          <el-table-column
              label="法人姓名"
              prop="legalPersonName">
          </el-table-column>
          <el-table-column
              label="剩余刻章次数"
              prop="balance">
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleAllocate(scope.row)">分 配</el-button>
            </template>
          </el-table-column>
        </el-table>


        <!--        <div class="pagination-container">-->
        <!--          <pagination-->
        <!--              :limit.sync="queryParams.pageSize"-->
        <!--              :page.sync="queryParams.pageNum"-->
        <!--              :total="total"-->
        <!--              @pagination="getTableData"-->

        <!--          />-->
        <!--        </div>-->

      </div>
    </el-card>

    <create
        v-if="visible"
        :visible.sync="visible"
        @handleQuery="handleQuery"
    />
  </div>
</template>

<script lang="ts">

import Create from "./components/create.vue";

export default {
  name: "index",
  components: {Create},
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,

      tableData: [],
      userInfo: {
        deptList: []
      },
      visible: false
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    openCreate() {
      this.visible = true
    },
    getInfo() {
      this.$http.get(this.$api.customerEnterprise.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        this.userInfo = res.data.data.kqUserInfo
      })
    },
    handleAllocate(row) {
      this.$http.get(this.$api.customerEnterprise.getInfo).then(res => {
        this.$prompt('请分配刻章次数', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputType: 'Number',
          inputErrorMessage: '请输入分配刻章次数',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm' && instance.inputValue > res.data.data.kqUserInfo.makeCount) {
              this.$message.error('您的刻章次数不足');
            } else if (action === 'confirm') {
              this.allocate(row, instance.inputValue)
              this.loading = true
              done();
            } else {
              done();
            }
          }
        })
      })
    },

    allocate(row, balance) {
      let params = {
        orgCode: row.orgCode,
        balance: balance
      }
      this.$http.post(this.$api.customerEnterprise.issueSealCount, params).then(res => {
        if (res.data.code == 200) {
          this.handleQuery()
          this.$message.success(res.data.msg)
          this.loading = false
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },

    getTableData() {
      this.$http.get(this.$api.customerEnterprise.getChildDeptList).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.loading = false;
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getTableData()
      this.getInfo()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        isKq: null
      },
          this.handleQuery();
    },
  }
}
</script>

<style lang="less" scoped>

</style>
